<template>
  <div>
    <!-- <pre>{{ select_duration }}</pre> -->
    <!-- <pre>{{ get_time }}</pre> -->
    <!-- <pre>{{ get_value }}</pre> -->
    <vs-card class="cardRadi">
      <div slot="header"><h3>Data Export</h3></div>

      <vs-row
        vs-align="flex-start"
        vs-type="flex"
        class="p-3"
        vs-justify="center"
        vs-w="12"
      >
        <vs-col vs-type="flex" vs-lg="6" vs-sm="6" vs-xs="12">
          <vs-select
            class="selectExample mt-2"
            label="Device"
            width="400px"
            v-model="get_time.device"
          >
            <vs-select-item
              :key="index"
              :value="item.text"
              :text="item.text"
              v-for="(item, index) in options_device"
            />
          </vs-select>
        </vs-col>
        <vs-col vs-type="flex" vs-lg="6" vs-sm="6" vs-xs="12">
          <!-- <vs-select
            class="selectExample mt-2"
            label="Duration"
            width="400px"
            v-model="get_time.mode"
          >
            <vs-select-item
              :key="index"
              :value="item.text"
              :text="item.text"
              v-for="(item, index) in options_duration"
            />
          </vs-select> -->
        </vs-col>
      </vs-row>

      <vs-row
        vs-align="flex-start"
        vs-type="flex"
        class="p-3"
        vs-justify="center"
        vs-w="12"
      >
        <vs-col vs-type="flex" vs-lg="6" vs-sm="6" vs-xs="12">
          <div style="display: flex; flex-direction: column">
            <label
              style="
                padding-left: 5px;
                color: var(--text-color-2);
                font-size: 0.85rem;
              "
              >Start Date</label
            >
            <datetime
              style="width: 400px"
              v-model="get_time.start"
              format="yyyy-MM-dd HH:mm:ss"
              type="datetime"
            />
          </div>
        </vs-col>
        <vs-col vs-type="flex" vs-lg="6" vs-sm="6" vs-xs="12">
          <div style="display: flex; flex-direction: column">
            <label
              style="
                padding-left: 5px;
                color: var(--text-color-2);
                font-size: 0.85rem;
              "
              >End Date</label
            >
            <datetime
              style="width: 400px"
              v-model="get_time.end"
              format="yyyy-MM-dd HH:mm:ss"
              type="datetime"
            />
          </div>
        </vs-col>

        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-lg="6"
          vs-sm="6"
          vs-xs="12"
        >
          <vs-button
            @click="submitReport(get_time)"
            color="success"
            class="btnSub mt-4 mb-2"
            type="filled"
            >Submit</vs-button
          >
        </vs-col>
      </vs-row>
    </vs-card>
    <!-- v-if="active" -->
  </div>
</template>

<script>
import XLSX from "xlsx";
export default {
  components: {},
  data: () => ({
    active: false,
    get_value: [],
    select_plan: "",
    select_duration: "",
    show_plan: "",
    options_plan: [
      { text: "Plastic Painting WWTP Plant", value: 1 },
      { text: "Aluminium Painting WWTP Plant", value: 2 },
      { text: "DAF Plant", value: 3 },
      { text: "Center Plant", value: 4 },
      { text: "AS Plant", value: 5 },
      { text: "MBR Plant", value: 6 },
      { text: "Recycle Plant", value: 7 },
      { text: "RO  Plant", value: 8 },
    ],
    options_week: [
      { text: "Week 1", value: "01" },
      { text: "Week 2", value: "08" },
      { text: "Week 3", value: "15" },
      { text: "Week 4", value: "22" },
      { text: "Week 5", value: "29" },
    ],
    options_duration: [
      // { text: "1 day", value: 1 },
      { text: "Week", value: 1 },
      { text: "Month", value: 2 },
      { text: "Year", value: 3 },
    ],
    options_device: [
      { text: "TVOC1", value: 1 },
      { text: "TVOC2", value: 2 },
      { text: "TVOC3", value: 3 },
      { text: "TVOC4", value: 4 },
      { text: "Wind Sensor", value: 5 },
      { text: "Air Pollution", value: 6 },
    ],
    select_month: { value: "01" },
    select_week: { value: "01" },
    select_year: null,
    get_month: null,
    get_week: null,
    get_year: null,
    options_year: [
      // { text: "1 day", value: 1 },
      // { text: "2021", value: 2021 },
      // { text: "2020", value: 2020 },
      // { text: "2019", value: 2019 },
      // { text: "2018", value: 2018 },
      // { text: "2017", value: 2017 },
    ],
    items: [],

    total_water_toilet: null,
    total_water_treat: null,
    total_electricity: null,
    avg_water_toilet: null,
    avg_water_treat: null,
    avg_electricity: null,
    exp_year: null,
    value_cal: {
      powerData: 0,
      waterData: 0,
    },
    get_time: {
      mode: "",
      device: "",
      start: "",
      end: "",
    },
    data_text: {
      type: 0,
      month: "",
      week: "",
      year: "",
    },
  }),
  methods: {
    errorFunc() {
      this.$vs.loading.close();
      this.$vs.notify({
        title: "Fetch Data Error",
        text: "Can't find any data",
        color: "danger",
        position: "top-center",
      });
      this.active = false;
    },
    async showPlan(item_plan, item_year, item_month, item_week) {
      console.log(item_year);
      this.$vs.loading();
      this.show_plan = item_plan;
      let arr_water_toilet = [];
      let arr_water_treat = [];
      let arr_electricity = [];
      this.total_water_toilet = null;
      this.total_water_treat = null;
      this.total_electricity = null;
      this.avg_water_toilet = null;
      this.avg_water_treat = null;
      this.avg_electricity = null;
      this.exp_year = null;
      this.items = [];
      this.get_month = "";
      this.get_week = "";
      this.get_year = "";

      switch (this.select_duration) {
        case 1:
          // this.items = this.items_week;
          this.exp_year = this.select_year;
          this.get_value = await this.$API
            .get(`yamaha/report/weekly/${item_year}-${item_month}-${item_week}`)
            .catch((error) => {
              this.errorFunc();
            });
          if (this.get_value.length == 0) {
            this.errorFunc();
          }
          this.data_text.type = 1;
          this.data_text.year = item_year;
          this.data_text.week = this.select_week.text;
          this.data_text.month = this.select_month.text;
          this.items = this.get_value.data;
          this.$vs.loading.close();
          break;
        case 2:
          // this.items = this.items_month;
          this.exp_year = this.select_year;
          this.get_value = await this.$API
            .get(`yamaha/report/monthly/${item_year}-${item_month}-01`)
            .catch((error) => {
              this.errorFunc();
            });
          if (this.get_value.length == 0) {
            this.errorFunc();
          }
          this.items = this.get_value.data;
          this.data_text.type = 2;
          this.data_text.year = item_year;
          this.data_text.week = "";
          this.data_text.month = this.select_month.text;
          this.select_week = "";
          this.$vs.loading.close();
          break;
        case 3:
          // this.items = this.items_year;
          this.exp_year = this.select_year;
          this.get_value = await this.$API
            .get(`yamaha/report/yearly/${item_year}-01-01`)
            .catch((error) => {
              this.errorFunc();
            });
          if (this.get_value.length == 0) {
            this.errorFunc();
          }
          this.items = this.get_value.data;
          this.data_text.type = 3;
          this.data_text.year = item_year;
          this.data_text.week = "";
          this.data_text.month = "";
          this.$vs.loading.close();
          break;
        default:
          console.log("Try looking up for a hint.");
          this.$vs.loading.close();
      }
      this.active = true;
    },
    caltotal(item) {},
    generateArrayOfYears() {
      var max = new Date().getFullYear();
      var min = max - 10;
      var years = [];

      for (var i = max; i >= min; i--) {
        years.push(i);
      }
      return years;
    },

    async submitReport(item) {
      console.log(item);
      this.$vs.loading();
      let body_command = item;
      let data_result = [];
      console.log(body_command);
      await this.$API
        .post(`yamaha/expost`, body_command)
        .then((result) => {
          console.log(result.data.message);

          // const dataWS = XLSX.utils.json_to_sheet(result.data.message);
          // const wb = XLSX.utils.book_new();
          // XLSX.utils.book_append_sheet(wb, dataWS);
          // XLSX.writeFile(wb, "aaaaaaaaa" + ".xlsx");

          if (!result.data.hasOwnProperty("message")) {
            this.$vs.loading.close();
            this.$vs.notify({
              title: "No data",
              position: "top-center",
              text: "Data undefined",
              icon: "warning",
              time: 6000,
              color: "warning",
            });
          } else {
            data_result = Object.keys(result.data.message);
            data_result.forEach((el) => {
              console.log(el);
              const dataWS = XLSX.utils.json_to_sheet(result.data.message[el]);
              const wb = XLSX.utils.book_new();
              XLSX.utils.book_append_sheet(wb, dataWS, el);
              XLSX.writeFile(wb, el + ".xlsx");
            });
            this.$vs.loading.close();
            this.$vs.notify({
              title: "Success",
              color: "success",
              position: "top-center",
              time: 6000,
              icon: "done",
            });
          }
        })
        .catch((error) => {
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Error",
            time: 6000,
            position: "top-center",
            text: "Please try again later.",
            icon: "warning",
            color: "danger",
          });
        });
    },
  },
  mounted() {},
};
</script>

<style scoped>
.btnSub {
  width: 100px;
  border-radius: 20px;
}
.cardRadi {
  border-radius: 20px;
}
</style>